// extracted by mini-css-extract-plugin
export default {"dropdownToggle":"AccountRoleWidget_dropdownToggle__H-MiZ","badge":"AccountRoleWidget_badge__sv8+8"};